import { createStore, useStore } from "zustand";
import { immer } from "zustand/middleware/immer";
import { subscribeWithSelector } from "zustand/middleware";

export type BetterAuthSession = {
	user: {
		id: string;
		email: string;
		emailVerified: boolean;
	};
	session: {
		id: string;
		token: string;
		expiresAt: Date;
		userId: string;
	};
};

type BetterAuthState = {
	isAuthLoading: boolean;
	session: BetterAuthSession | null;
};

type BetterAuthActions = {
	setAuthLoading: (isLoading: boolean) => void;
	setSession: (session: BetterAuthSession | null) => void;
};

export type BetterAuthStoreProps = BetterAuthState & BetterAuthActions;

export const betterAuthStore = createStore<BetterAuthStoreProps>()(
	subscribeWithSelector(
		immer((set) => ({
			isAuthLoading: false,
			session: null,
			setAuthLoading: (isLoading: boolean) =>
				set((state) => {
					state.isAuthLoading = isLoading;
				}),
			setSession: (session: BetterAuthSession | null) =>
				set((state) => {
					state.session = session;
				}),
		})),
	),
);

export type BetterAuthStore = typeof betterAuthStore;

export const useBetterAuthStore = () => useStore(betterAuthStore);
